//import auth from 'firebase/auth';
import firebase from 'firebase'
import * as api from '../api';
import {browserHistory} from 'react-router';


/** ERRORS **/

export function clearDataError(error) {
    return (dispatch) => {
        const e = {}
        e[error] = null
        dispatch(onDataError(e))
    }
}

/**USER ACTIONS **/
export function loginFirebaseUser(user) {
    return (dispatch) => {
        dispatch(login(user));
    }
}

export function getETMSUser() {
    //console.log('getETMSUser')

    return (dispatch) => {
        dispatch(loading({getETMSUser: true}))

        //console.log('getETMSUser:')

        api.getETMSUser().then((user) => {
            console.log('getETMSUser>>', user)
            dispatch(ETMSUserReceived(user));
            dispatch(loading({getETMSUser: false}))
        }, error => {
            console.log('action.getETMSUser failed', error.code, error.message);
            dispatch(onError('ETMS_LOGIN_ERROR'))
            dispatch(showAlert('warning','Unable to log in ETMS user',''))
            dispatch(loading({getETMSUser: false}))
        });
    }
}

export function updateETMSUser(user) {
    return (dispatch) => {
        dispatch(loading({updateETMSUser: true}));
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info','Updating account details','',alertId))
        api.updateETMSUser(user).then((userResponse) => {
            console.log("action etms user updated:", userResponse);
            dispatch(ETMSUserReceived(userResponse));
            dispatch(showAlert('success','Account updated','',null,alertId))
            dispatch(loading({updateETMSUser: false}));
        }, error => {
            console.log(error.code, error.message);
            dispatch(loading({updateETMSUser: false}));
            dispatch(showAlert('warning','Unable to update user','',null,alertId))
        });
    }
}

export function loginPressed(email, password) {
    return (dispatch) => {
        console.log('loginPressed', email, password)
        dispatch(loading({loginPressed: true}));
        dispatch(onError());
        firebase.auth().signInWithEmailAndPassword(email, password)
            .then((user) => {
                console.log('signInWithEmailAndPassword success', user)
                //const isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
                if (user && !user.apiKey && user.j) {
                    //console.log('setting user localStorage for IE, edge etc')
                    //console.log('user.j', user.j)
                    user.apiKey = user.j
                    const key = `firebase:authUser:${user.j}:[DEFAULT]`
                    localStorage.setItem(key, typeof user === 'object' ? JSON.stringify(user) : user)
                }

                dispatch(loading({loginPressed: false}));
                dispatch(pwReset(false));
                dispatch(login(user));
                dispatch(getETMSUser());
                dispatch(retrieveGroup())
                //console.log('push dashboard')
                browserHistory.push('/dashboard')
            }, error => {
                console.log(error.code, error.message);
                dispatch(loading({loginPressed: false}));
                dispatch(onError(error))
            })
    }
}


export function onETMSResponseError(error, user) {
    return (dispatch) => {
        if (error.code === 'user_exists') {
            dispatch(loading(false));
            dispatch(pwReset(false));
            dispatch(login(user));
            dispatch(getETMSUser());
            browserHistory.push('/dashboard')
        } else {
            dispatch(loading(false));
            dispatch(onError(error))
        }
    }
}


export function signUpPressed(data) {
    return (dispatch) => {
        dispatch(loading(true));
        dispatch(onError());
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info','Signing up user','',alertId))
        firebase.auth().createUserWithEmailAndPassword(data.email, data.password)
            .then((user) => {
                user.sendEmailVerification().then((r) => {
                    console.log('send verification email success', r)
                }, err => {
                    console.log('send verification email ERROR', err)
                })
                console.log('response for creating a new user', user);
                return Promise.all([user, api.createUserInDatabase({
                    email: data.email,
                    name: data.name,
                    phone: data.phone
                })])
            }).then(([user, ETMSUser]) => {
                console.log('promise all res ', user, ETMSUser)

                dispatch(loading(false));
                dispatch(pwReset(false));
                dispatch(login(user));
                dispatch(ETMSUserReceived(ETMSUser));
                dispatch(showAlert('success', 'User created', '',null,alertId))
                browserHistory.push('/dashboard')
            }, error => {
                console.log('signup', error);
                dispatch(loading(false));
                dispatch(onETMSResponseError(error));
                dispatch(showAlert('warning','Unable to create user',error.message,null,alertId))
            });
    }
}

export function sendVerificationEmail() {
    return (dispatch) => {
        dispatch(loading(true));
        dispatch(showAlert("success", "Sending email verification.", ""));
        let user = firebase.auth().currentUser;
        console.log(user)
        if (user) {
            user.sendEmailVerification().then(() => {
                dispatch(loading(false));
                dispatch(showAlert("success", "Email verification sent.", ""));
            }, err => {
                dispatch(loading(false));
                dispatch(showAlert("error", "Sending email verification failed.", ""));
                console.log('send verification email ERROR', err)
            });
        } else {

            dispatch(showAlert("error", "Sending email verification failed.", "No current user to send email too."));
        }
    }
}

// export function createOtherUser(data) {
//     return (dispatch) => {
//         dispatch(loading({createOtherUser: true}));
//         dispatch(onError());
//         const alertId = (new Date()).getTime()
//         dispatch(showAlert('info','Creating new user','', alertId));
//
//         api.createUserInFirebaseAndLogBackIn(data)
//             .then((ETMSUser) => {
//                 console.log('did create database user', ETMSUser)
//                 dispatch(loading({createOtherUser: false}));
//                 dispatch(otherETMSUserReceived(ETMSUser));
//                 dispatch(showAlert('success','New user created',data.email || '',null,alertId))
//             }, error => {
//                 console.log(error.code, error.message);
//                 dispatch(loading({createOtherUser: false}));
//                 dispatch(onError(error))
//                 dispatch(showAlert('warning','Unable to create user','',null,alertId))
//             })
//     }
// }

export function createOtherUser2(data) {

    //console.log('createOtherUser2', data)

    return (dispatch) => {
        dispatch(loading({createOtherUser: true}));
        dispatch(onError());
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info','Creating new user','', alertId));

        api.createUserWithFirebase(data)
            .then((ETMSUser) => {
                console.log('did create database user', ETMSUser)
                dispatch(loading({createOtherUser: false}));
                dispatch(otherETMSUserReceived(ETMSUser));
                dispatch(showAlert('success','New user created',data.email || '',null,alertId))
            }, error => {
                console.log(error.code, error.message);
                dispatch(loading({createOtherUser: false}));
                dispatch(onError(error))
                dispatch(showAlert('warning','Unable to create user','',null,alertId))
            })
    }
}

export function addUserRole(userId, role) {
    return (dispatch) => {
        dispatch(loading({addUserRole: true}));
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info','Adding user role','',alertId))
        api.addUserRole(userId, role).then((user) => {
            console.log("user role added:", user);
            dispatch(otherETMSUserReceived(user));
            dispatch(loading({addUserRole: false}));
            dispatch(showAlert('success','Added user role','',null,alertId))
        }, error => {
            console.log(error.code, error.message);
            dispatch(loading({addUserRole: false}));
            dispatch(showAlert('warning','Unable to add user role','',null,alertId))
        });
    }
}

export function removeUserRole(userId, role) {
    return (dispatch) => {
        dispatch(loading({removeUserRole: true}));
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info','Removing user role','',alertId))
        api.removeUserRole(userId, role).then((user) => {
            console.log("user role removed:", user);
            dispatch(otherETMSUserReceived(user));
            dispatch(loading({removeUserRole: false}));
            dispatch(showAlert('success','Removed user role','',null,alertId))
        }, error => {
            console.log(error.code, error.message);
            dispatch(loading({removeUserRole: false}));
            dispatch(showAlert('warning','Unable to remove user role','',null,alertId))
        });
    }
}

export function pwReset(bool) {
    return {
        type: 'PASSWORD_RESET',
        passwordReset: bool
    }
}

export function resetPassword(email) {
    //console.log('passwordResetPressed', email)
    return (dispatch) => {
        dispatch(loading({resetPassword: true}));
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info','Sending password reset email','',alertId))
        firebase.auth().sendPasswordResetEmail(email).then(() => {
                console.log('password reset email sent', arguments)
                dispatch(loading({resetPassword: false}));
                dispatch(showAlert('success','Reset email sent','',null,alertId))
                dispatch(pwReset(true))
            }, error => {
                console.log(error, error.code, error.message)
                dispatch(loading({resetPassword: false}));
                dispatch(showAlert('warning','Unable to send password reset email',error.message,null,alertId))
            })
    }
}

export function logout() {
    return {
        type: 'LOG_OUT'
    }
}

export function logoutPressed() {
    return (dispatch) => {
        dispatch(loading(true));
        firebase.auth().signOut().then(() => {
                dispatch(loading(false));
                dispatch(logout());
                browserHistory.push('/')
            }, err => {
                console.log('ERROR', err)
            })
    }
}

/** BUDGET **/

export function retrieveBudget() {
    return (dispatch) => {
        dispatch(loading({retrieveBudget: true}))
        api.retrieveBudget().then((budget) => {
            //console.log("got budget:", budget)
            dispatch(budgetReceived(budget))
            dispatch(loading({retrieveBudget: false}))
        }, error => {
            console.log('retrieveBudget error', error)
            dispatch(loading({retrieveBudget: false}))
        });
    }
}

/** TESTS **/

export function createTest(data, onSuccess) {
    console.log('createTest', data)
    return (dispatch) => {
        dispatch(loading({createTest: true}));
        dispatch(onDataError({createTest: null, createTestCode: null}));
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info', 'Creating engine test', '', alertId))
        api.createTest(data).then((test) => {
            console.log("engine test created:", test);
            dispatch(testReceived(test));
            dispatch(loading({createTest: false, createTestCode: null}));
            dispatch(showAlert('success', 'Engine test created', `Test reference: ${test.reference || ''}`, null, alertId))
            dispatch(retrieveBudget())
            onSuccess()
        }, error => {
            console.log('createTest error', error.code, error.message, {createTest: error.message});
            dispatch(onDataError({createTest: error.message, createTestCode: error.code}));
            dispatch(loading({createTest: false}));
            dispatch(showAlert('warning', 'Unable to create engine test', error.message || '', null, alertId))
        });
    }
}

export function updateTest(testId, data, onSuccess) {
    return (dispatch) => {
        dispatch(loading({updateTest: true}));
        dispatch(onDataError({updateTest: null}));
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info', 'Updating engine test', '', alertId))
        api.updateTest(testId, data).then((test) => {
            console.log("engine test updated:", test);
            dispatch(testReceived(test));
            dispatch(loading({updateTest: false}));
            dispatch(showAlert('success', 'Engine test updated', `Test reference: ${test.reference || ''}`, null, alertId))
            dispatch(retrieveBudget())
            if (onSuccess) {
                onSuccess()
            }
        }, error => {
            console.log('updateTest error',  error.code, error.message);
            dispatch(onDataError({updateTest: error.message}));
            dispatch(loading({updateTest: false}));
            dispatch(showAlert('warning', 'Unable to update engine test', '', null, alertId))
        });
    }
}

export function didPrintTest(testId) {
    return (dispatch) => {
        api.didPrintTest(testId).then((test) => {
            console.log("didPrintTest :", test);
            dispatch(testReceived(test));
        }, error => {
            console.log('didPrintTest error',  error.code, error.message);
        });
    }
}

export function retrieveTestsInRange(start, end, showNotification, forAdminReport) {
    return (dispatch) => {
        dispatch(loading({retrieveTestsInRange: true}));
        const alertId = (new Date()).getTime()
        if (showNotification) {
            dispatch(showAlert('info', 'Retrieving engine tests', '', alertId))
        }
        api.retrieveTestsInRange(start, end).then((tests) => {
            //console.log("engine tests received:", tests);
            dispatch(testsReceived(tests, forAdminReport));
            if (showNotification) {
                dispatch(showAlert('success', 'Engine tests received', '', null, alertId))
            }
            dispatch(loading({retrieveTestsInRange: false}));
        }, error => {
            console.log(error.code, error.message);
            dispatch(loading({retrieveTestsInRange: false}));
            if (showNotification) {
                dispatch(showAlert('warning', 'Unable to get engine tests', '', null, alertId))
            }
        });
    }
}

export function unplannedTestsStatus() {
    return (dispatch) => {
        dispatch(loading({unplannedTestsStatus: true}));
        api.unplannedTestsStatus().then((status) => {
            //console.log("engine tests unplanned status:", status);
            dispatch(unplannedTestsStatusReceived(status));
            dispatch(loading({unplannedTestsStatus: false}));
        }, error => {
            console.log(error.code, error.message);
            dispatch(loading({unplannedTestsStatus: false}));
        });
    }
}

/** upload doc **/

export function uploadDocument(files) {

    console.log('uploadDocument', files)
    return (dispatch) => {
        dispatch(loading({uploadDocument: true}))
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info', 'Uploading document', '', alertId))
        api.uploadDocument(files).then((url) => {
            console.log("doc uploaded:", url);
            dispatch(documentUploaded(url));
            dispatch(loading({uploadDocument: false}));
            dispatch(showAlert('success','Uploaded document','',null,alertId))
        }, error => {
            console.log(error.code, error.message);
            dispatch(loading({uploadDocument: false}));
            dispatch(showAlert('warning','Unable to upload document','',null,alertId))
        });
    }
}

/** GROUPS **/

export function createGroup(data) {
    console.log('createGroup', data)
    return (dispatch) => {
        dispatch(loading({createGroup: true}));
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info','Creating agency','',alertId))
        api.createGroup(data).then((group) => {
            console.log("group created:", group);
            dispatch(groupReceived(group));
            dispatch(loading({createGroup: false}));
            dispatch(showAlert('success','Created agency','',null,alertId))
        }, error => {
            console.log(error.code, error.message);
            dispatch(loading({createGroup: false}));
            dispatch(showAlert('warning','Unable to create agency','',null,alertId))
        });
    }
}

export function retrieveGroup() {
    //console.log('retrieveGroup')
    return (dispatch) => {
        dispatch(userGroupReceived(undefined))
        dispatch(loading({retrieveGroup: true}));
        api.retrieveGroup().then((group) => {
            console.log("group received:", group);
            dispatch(userGroupReceived(group));
            dispatch(loading({retrieveGroup: false}));
        }, error => {
            console.log('retrieve group err', error);
            dispatch(loading({retrieveGroup: false}));
        });
    }
}

export function retrieveGroups() {
    return (dispatch) => {
        dispatch(loading({retrieveGroups: true}));
        api.retrieveGroups().then((groups) => {
            console.log("groups received:", groups);
            dispatch(groupsReceived(groups));
            dispatch(loading({retrieveGroups: false}));
        }, error => {
            console.log('retrieve groups err', error);
            dispatch(loading({retrieveGroups: false}));
        });
    }
}

export function retrieveUsersInGroup(groupId) {
    return (dispatch) => {
        dispatch(loading({retrieveUsersInGroup: true}));
        api.retrieveUsersInGroup(groupId).then((users) => {
            //console.log("group users received:", users);
            dispatch(groupUsersReceived(users));
            dispatch(loading({retrieveUsersInGroup: false}));
        }, error => {
            console.log('retrieve group users err', error);
            dispatch(loading({retrieveUsersInGroup: false}));
        });
    }
}

export function addUserToGroup(groupId, userId) {
    return (dispatch) => {
        dispatch(loading({addUserToGroup: true}));
        api.addUserToGroup(groupId, userId).then((user) => {
            console.log("user received:", user);
            dispatch(groupUserAdded(user));
            dispatch(loading({addUserToGroup: false}));
        }, error => {
            console.log('add group users err', error);
            dispatch(loading({addUserToGroup: false}));
        });
    }
}

export function removeUserFromGroup(groupId, userId) {
    return (dispatch) => {
        dispatch(loading({removeUserFromGroup: true}));
        api.removeUserFromGroup(groupId, userId).then((user) => {
            console.log("removed group user:", user);
            dispatch(groupUserRemoved(user));
            dispatch(loading({removeUserFromGroup: false}));
        }, error => {
            console.log('remove group users err', error);
            dispatch(loading({removeUserFromGroup: false}));
        });
    }
}

export function deleteUser(userId) {
    return (dispatch) => {
        dispatch(loading({deleteUser: true}));
        api.deleteUser(userId).then((user) => {
            console.log("deleted user:", user);
            dispatch(userDeleted(user));
            dispatch(loading({deleteUser: false}));
        }, error => {
            console.log('Delete user err', error);
            dispatch(loading({deleteUser: false}));
        });
    }
}

/** REPORTS **/

export function getReport(year, quarter) {
    return (dispatch) => {
        dispatch(loading({getReport: true}));
        api.getReport(year, quarter).then((report) => {
            console.log("report received:", report);
            dispatch(reportReceived({
                report: report,
                year: year,
                quarter: quarter,
                error: null
            }));
            dispatch(loading({getReport: false}));
        }, error => {
            console.log('get report err', error);
            dispatch(reportReceived({error: `Error getting report: ${error.message || ''}`}));
            dispatch(loading({getReport: false}));
        });
    }
}

export function getMDAYearly(year) {
    return (dispatch) => {
        dispatch(loading({getMDAYearly: true}));
        api.getMDAYearly(year).then((data) => {
            console.log("getMDAYearly received:", data);
            dispatch(MDAYearlyReceived({
                data: data,
                year: year,
                error: null
            }));
            dispatch(loading({getMDAYearly: false}));
        }, error => {
            console.log('getMDAYearly err', error);
            dispatch(MDAYearlyReceived({error: `Error getting data: ${error.message || ''}`}));
            dispatch(loading({getMDAYearly: false}));
        });
    }
}

/** NOTIFICATIONS **/

export function displayNotification(notification) {
    return (dispatch) => {
        dispatch(notificationReceived(notification));
    }
}

export function removeAllNotifications() {
    return (dispatch) => {
        dispatch(removeAllNotificationsReceived());
    }
}

export function removeNotification(notification) {
    return (dispatch) => {
        dispatch(removeNotificationReceived(notification));
    }
}

export function simpleAlert(headline) {
    return (dispatch) => {
        let alert = {
                id: (new Date()).getTime(),
                type: 'info',
                headline: headline,
                message: ''
            };
        dispatch(notificationReceived(alert));
    }
}

export function showAlert(type, headline, message, id, hideId) {
    //type: info success warning danger
    return (dispatch) => {
        let alert = {
                id: id || (new Date()).getTime(),
                type: type,
                headline: headline,
                message: message || ''
            };
        dispatch(notificationReceived(alert));
        if (hideId) {
            dispatch(hideAlertId(hideId))
        }
    }
}

export function hideAlertId(id) {
    return (dispatch) => {
        dispatch(removeNotificationIdReceived(id));
    }
}

export function sendSupportMessage(values) {
    return (dispatch) => {
        dispatch(loading({sendSupportMessage: true}));
        const alertId = (new Date()).getTime()
        dispatch(showAlert('info','Sending support message','',alertId))
        api.sendSupportMessage(values).then((message) => {
            console.log("message sent");
            dispatch(showAlert('success', 'Support message sent', `Message reference: ${message.reference}`, null, alertId))
            dispatch(loading({sendSupportMessage: false}));
        }, error => {
            console.log('get report err', error);
            dispatch(showAlert('warning', 'Unable to send support message', error.message || '', null, alertId))
            dispatch(loading({sendSupportMessage: false}));
        });
    }
}

/** RESPONSE METHODS **/

// function pageReceived(page) {
//     return {
//         type: 'PAGE_RECEIVED',
//         page: page
//     }
// }

export function notificationReceived(notification) {
    return {
        type: 'NOTIFICATION_RECEIVED',
        notification: notification
    }
}

export function removeNotificationReceived(notification) {
    return {
        type: 'REMOVE_NOTIFICATION_RECEIVED',
        notification: notification
    }
}

export function removeAllNotificationsReceived() {
    return {
        type: 'REMOVE_ALL_NOTIFICATIONS_RECEIVED'
    }
}

export function removeNotificationIdReceived(notificationId) {
    return {
        type: 'REMOVE_NOTIFICATION_ID_RECEIVED',
        notificationId: notificationId
    }
}

export function loading(val) {
    return {
        type: 'IS_LOADING',
        loading: val
    };
}

export function login(user) {
    return {
        type: 'LOG_IN',
        user
    };
}

export function onError(error) {
    return {
        type: 'ERROR',
        error
    }
}

export function onDataError(error) {
    return {
        type: 'DATA_ERROR',
        error: error
    }
}

function ETMSUserReceived(user) {
    //console.log('ETMSUserReceived')
    return {
        type: 'ETMS_USER_RECEIVED',
        ETMSUser: user
    }
}

function otherETMSUserReceived(user) {
    return {
        type: 'OTHER_ETMS_USER_RECEIVED',
        newUser: user
    }
}

function testReceived(test) {
    return {
        type: 'TEST_RECEIVED',
        test: test
    }
}

function testsReceived(tests, forAdminReport) {
    return {
        type: 'TESTS_RECEIVED',
        tests: tests,
        forAdminReport: forAdminReport
    }
}

function documentUploaded(uploadUrl) {
    return {
        type: 'DOCUMENT_UPLOADED',
        uploadUrl: uploadUrl
    }
}

function groupReceived(group) {
    return {
        type: 'GROUP_RECEIVED',
        group: group
    }
}

function userGroupReceived(group) {
    return {
        type: 'USER_GROUP_RECEIVED',
        group: group
    }
}

function groupsReceived(groups) {
    return {
        type: 'GROUPS_RECEIVED',
        groups: groups
    }
}

function groupUserAdded(user) {
    return {
        type: 'GROUP_USER_ADDED',
        user: user
    }
}

function groupUserRemoved(user) {
    return {
        type: 'GROUP_USER_REMOVED',
        user: user
    }
}

function userDeleted(user) {
    return {
        type: 'USER_DELETED',
        user: user
    }
}

function groupUsersReceived(users) {
    return {
        type: 'GROUP_USERS_RECEIVED',
        groupUsers: users
    }
}

function budgetReceived(budget) {
    return {
        type: 'BUDGET_RECEIVED',
        budget: budget
    }
}

function reportReceived(report) {
    return {
        type: 'REPORT_RECEIVED',
        report: report
    }
}

function MDAYearlyReceived(data) {
    return {
        type: 'MDA_YEARLY_RECEIVED',
        data: data
    }
}

function unplannedTestsStatusReceived(status) {
    return {
        type: 'UNPLANNED_STATUS_RECEIVED',
        unplannedTestsStatus: status
    }
}








// WEBPACK FOOTER //
// ./src/actions/index.js